import { InjectionKey } from "@lib/svelte-typed-context";

export const tabsNameContextToken: InjectionKey<string> = Symbol(
    "tabsNameContextToken"
);
